import { render, staticRenderFns } from "./kelengkapan.vue?vue&type=template&id=69dd9670&"
import script from "./kelengkapan.vue?vue&type=script&lang=js&"
export * from "./kelengkapan.vue?vue&type=script&lang=js&"
import style0 from "./kelengkapan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports